import React from "react";
import { FaGraduationCap, FaArrowRight, FaFlask, FaPills, FaCapsules, FaMicroscope, FaIndustry, FaCheckCircle, FaStar, FaAward, FaUserMd, FaHospitalUser, FaGlobe, FaUniversity, FaBuilding, FaClipboardList } from "react-icons/fa";
import { MdHealthAndSafety, MdMedicalServices, MdVerified, MdSchool, MdTimeline, MdAttachMoney, MdEventNote, MdPeople, MdMenuBook, MdBusinessCenter, MdScience } from "react-icons/md";
import { GiNurseFemale, GiMedicinePills, GiHealthNormal, GiFemale } from "react-icons/gi";
import { BiCertification } from "react-icons/bi";
import { RiGovernmentLine, RiAdminLine } from "react-icons/ri";

const NursingCoursesSection = () => {
  // Updated nursingCourses array with new GNM details
  const nursingCourses = [
    {
      title: "B.Sc. Nursing",
      fullForm: "Bachelor of Science in Nursing, code 2220387 ",
      duration: "4 Years",
      eligibility: "10+2 PCB (50%)",
      fees: "₹110,000 per year",
      seats: "40",
      icon: <GiNurseFemale className="text-3xl" />,
      color: "from-blue-600 to-blue-500",
      lightColor: "from-blue-50 to-blue-100",
      features: [
        "Medical-Surgical Nursing",
        "Psychiatric Nursing",
        "Community Health Nursing",
        "Nursing Research & Administration"
      ],
      career: ["Teaching Hospitals", "Research Institutes", "Overseas Opportunities", "Nursing Administration", "Critical Care Units", "Nursing Education"],
      highlights: ["Clinical Training", "Govt. Approved", "Placement Aid", "Research Focus"]
    },
    {
      title: "GNM",
      fullForm: "General Nursing and Midwifery ,code 1537",
      duration: "3 Years",
      eligibility: "10+2 (Any Stream)",
      fees: "₹90,000 per year",
      seats: "40",
      icon: <MdHealthAndSafety className="text-3xl" />,
      color: "from-green-600 to-green-500",
      lightColor: "from-green-50 to-green-100",
      features: [
        "Medical-Surgical Nursing",
        "Pediatric Nursing",
        "Psychiatric Nursing",
        "Midwifery & Obstetric Care"
      ],
      career: ["Multi-speciality Hospitals", "Pharma Companies", "Research Labs", "Community Health Centers"],
      highlights: ["PCI Approved", "Industry Integrated", "Global Opportunities"],
      additionalCareers: ["Clinical Research", "Hospital Admin", "Quality Assurance", "Regulatory Affairs"]
    }
  ];
  
  // Updated pharmacy careers data for GNM
  const pharmacyCareers = [
    {
      title: "Career in Pharmacy",
      icon: <FaCapsules className="text-xl" />,
      description: "Clinical, Retail, Hospital Pharmacy",
      opportunities: ["Community Pharmacist", "Clinical Pharmacist", "Hospital Pharmacist"],
      color: "from-blue-600 to-blue-500"
    },
    {
      title: "Research & Development",
      icon: <FaFlask className="text-xl" />,
      description: "Drug Discovery, Clinical Research",
      opportunities: ["Research Scientist", "Clinical Research Associate"],
      color: "from-blue-600 to-green-600"
    }
  ];

  return (
    <section className="py-16 px-4 bg-gradient-to-br from-slate-50 via-white to-slate-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <div className="flex justify-center mb-4">
            <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-blue-100 text-blue-700 text-sm font-semibold">
              <MdMedicalServices className="text-lg" />
              Nursing & Pharmacy Programs 2025-26
            </span>
          </div>
          
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            <span className="bg-gradient-to-r from-blue-700 via-blue-600 to-green-600 bg-clip-text text-transparent">
              Shape the Future of Healthcare
            </span>
          </h2>
          
          <p className="text-gray-600 text-lg max-w-3xl mx-auto leading-relaxed">
            Embark on a rewarding career in healthcare with our comprehensive nursing and pharmacy programs. 
            State-of-the-art facilities, expert faculty, and 100% placement assistance.
          </p>

          <div className="flex flex-wrap justify-center gap-6 mt-6">
            <div className="flex items-center gap-2 text-gray-600">
              <FaCheckCircle className="text-blue-600 text-lg" />
              <span className="text-sm font-medium">Govt. Approved</span>
            </div>
            <div className="flex items-center gap-2 text-gray-600">
              <FaStar className="text-blue-600 text-lg" />
              <span className="text-sm font-medium">4.8/5 Rating</span>
            </div>
            <div className="flex items-center gap-2 text-gray-600">
              <FaAward className="text-green-600 text-lg" />
              <span className="text-sm font-medium">NAAC A+ Grade</span>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          {/* B.Sc. Nursing Card */}
          <div className="group bg-white rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 overflow-hidden border border-gray-100">
            <div className={`bg-gradient-to-r ${nursingCourses[0].color} p-6 text-white relative overflow-hidden`}>
              <div className="absolute inset-0 bg-white/10 transform -skew-y-12"></div>
              <div className="absolute -right-8 -top-8 w-24 h-24 bg-white/20 rounded-full group-hover:scale-150 transition-transform duration-700"></div>
              <div className="absolute -left-8 -bottom-8 w-32 h-32 bg-white/20 rounded-full group-hover:scale-150 transition-transform duration-700 delay-200"></div>
              
              <div className="relative flex items-center gap-4">
                <div className="bg-white/30 p-3 rounded-2xl backdrop-blur-sm border border-white/20">
                  {nursingCourses[0].icon}
                </div>
                <div>
                  <div className="flex items-center gap-2 mb-1">
                    <h3 className="text-3xl font-bold">{nursingCourses[0].title}</h3>
                    <span className="bg-white/30 text-xs px-2 py-1 rounded-full backdrop-blur-sm">
                      {nursingCourses[0].duration}
                    </span>
                  </div>
                  <p className="text-sm text-white/90 font-medium">{nursingCourses[0].fullForm}</p>
                </div>
              </div>
            </div>
            <div className="p-6">
              <div className="mb-5 bg-gradient-to-r from-blue-50 to-indigo-50 p-4 rounded-xl border border-blue-200 relative overflow-hidden">
                <div className="absolute top-0 right-0 w-16 h-16 bg-blue-200/30 rounded-full -mr-8 -mt-8"></div>
                <div className="flex items-start gap-3 relative">
                  <div className="bg-blue-200 p-2 rounded-full">
                    <MdMenuBook className="text-blue-700 text-xl" />
                  </div>
                  <div>
                    <p className="text-xs font-semibold text-blue-800 mb-1">📖 About the Course</p>
                    <p className="text-sm text-gray-700 leading-relaxed">
                      B.Sc. Nursing is a four-year undergraduate program that prepares students to become professional nurses with advanced clinical skills and knowledge. The curriculum covers all aspects of nursing, including medical-surgical nursing, pediatric nursing, psychiatric nursing, community health nursing, and nursing research.
                    </p>
                  </div>
                </div>
              </div>
              
              <div className="grid grid-cols-3 gap-3 mb-5">
                <div className="bg-gray-50 p-3 rounded-xl border border-gray-100 text-center">
                  <p className="text-xs text-gray-500 mb-1">Eligibility</p>
                  <p className="text-sm font-semibold text-gray-800">{nursingCourses[0].eligibility}</p>
                </div>
                <div className="bg-gray-50 p-3 rounded-xl border border-gray-100 text-center">
                  <p className="text-xs text-gray-500 mb-1">Duration</p>
                  <p className="text-sm font-semibold text-gray-800">{nursingCourses[0].duration}</p>
                </div>
                <div className="bg-gray-50 p-3 rounded-xl border border-gray-100 text-center">
                  <p className="text-xs text-gray-500 mb-1">Fees / Year</p>
                  <p className="text-sm font-semibold text-gray-800">{nursingCourses[0].fees}</p>
                </div>
              </div>
              
              <div className="mb-5">
                <p className="text-sm font-semibold text-gray-700 mb-3 flex items-center gap-2">
                  <span className="w-1 h-4 bg-blue-600 rounded-full"></span>
                  Program Highlights
                </p>
                <div className="grid grid-cols-2 gap-2">
                  {nursingCourses[0].features.map((feature, idx) => (
                    <div key={idx} className="flex items-center gap-2 text-gray-700 bg-gray-50 p-2 rounded-lg">
                      <FaCheckCircle className="text-blue-600 text-sm flex-shrink-0" />
                      <span className="text-sm">{feature}</span>
                    </div>
                  ))}
                </div>
              </div>              
              <div className="mb-5 flex flex-wrap gap-2">
                {nursingCourses[0].highlights.map((item, idx) => (
                  <div key={idx} className="flex items-center gap-1 text-xs text-gray-600 bg-gray-100 px-2 py-1 rounded-full">
                    {idx === 0 && <FaHospitalUser className="text-blue-600" />}
                    {idx === 1 && <RiGovernmentLine className="text-green-600" />}
                    {idx === 2 && <FaGraduationCap className="text-purple-600" />}
                    {idx === 3 && <FaMicroscope className="text-amber-600" />}
                    <MdVerified className="text-blue-600" />
                    {item}
                  </div>
                ))}
              </div>

              <div className="mb-5 bg-gray-50 p-3 rounded-xl border border-gray-200">
                <p className="text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
                  <MdEventNote className="text-blue-600" />
                  Admission Details
                </p>
                <div className="grid grid-cols-3 gap-2 text-center text-xs">
                  <div className="bg-white p-2 rounded-lg shadow-sm">
                    <p className="text-gray-500">Start Date</p>
                    <p className="font-bold text-gray-800">1 April 2026</p>
                  </div>
                  <div className="bg-white p-2 rounded-lg shadow-sm">
                    <p className="text-gray-500">Total Seats</p>
                    <p className="font-bold text-gray-800">{nursingCourses[0].seats}</p>
                  </div>
                  <div className="bg-white p-2 rounded-lg shadow-sm">
                    <p className="text-gray-500">Mode</p>
                    <p className="font-bold text-gray-800">Merit / Entrance</p>
                  </div>
                </div>
              </div>

              <div className="flex gap-3">
                <button className="flex-1 py-3 px-4 bg-gradient-to-r from-blue-600 to-blue-700 text-white text-sm font-semibold rounded-xl hover:from-blue-700 hover:to-blue-800 transition-all duration-300 transform group-hover:scale-[1.02] flex items-center justify-center gap-2 shadow-lg shadow-blue-200">
                  Apply Now <FaArrowRight className="group-hover:translate-x-1 transition-transform" />
                </button>
                <button className="px-4 py-3 border-2 border-blue-600 text-blue-600 text-sm font-semibold rounded-xl hover:bg-blue-50 transition-all duration-300">
                  Details
                </button>
              </div>
            </div>
          </div>

          {/* GNM Card - Updated with new content */}
          <div className="group bg-white rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 overflow-hidden border border-gray-100">
            <div className={`bg-gradient-to-r ${nursingCourses[1].color} p-6 text-white relative overflow-hidden`}>
              <div className="absolute inset-0 bg-white/10 transform -skew-y-12"></div>
              <div className="absolute -right-8 -top-8 w-24 h-24 bg-white/20 rounded-full group-hover:scale-150 transition-transform duration-700"></div>
              <div className="absolute -left-8 -bottom-8 w-32 h-32 bg-white/20 rounded-full group-hover:scale-150 transition-transform duration-700 delay-200"></div>
              
              <div className="relative flex items-center gap-4">
                <div className="bg-white/30 p-3 rounded-2xl backdrop-blur-sm border border-white/20">
                  {nursingCourses[1].icon}
                </div>
                <div>
                  <div className="flex items-center gap-2 mb-1">
                    <h3 className="text-3xl font-bold">{nursingCourses[1].title}</h3>
                    <span className="bg-white/30 text-xs px-2 py-1 rounded-full backdrop-blur-sm">
                      {nursingCourses[1].duration}
                    </span>
                  </div>
                  <p className="text-sm text-white/90 font-medium">{nursingCourses[1].fullForm}</p>
                </div>
              </div>
            </div>

            <div className="p-6">
              {/* About the Course Section for GNM */}
              <div className="mb-5 bg-gradient-to-r from-green-50 to-emerald-50 p-4 rounded-xl border border-green-200 relative overflow-hidden">
                <div className="absolute top-0 right-0 w-16 h-16 bg-green-200/30 rounded-full -mr-8 -mt-8"></div>
                <div className="flex items-start gap-3 relative">
                  <div className="bg-green-200 p-2 rounded-full">
                    <MdMenuBook className="text-green-700 text-xl" />
                  </div>
                  <div>
                    <p className="text-xs font-semibold text-green-800 mb-1">📖 About the Course</p>
                    <p className="text-sm text-gray-700 leading-relaxed">
                      GNM (General Nursing and Midwifery) is a diploma course that prepares students to become professional nurses who can work in hospitals, nursing homes, and community health settings. The program covers all aspects of nursing care, including medical-surgical nursing, pediatric nursing, psychiatric nursing, and midwifery.
                    </p>
                  </div>
                </div>
              </div>
              
              <div className="grid grid-cols-3 gap-3 mb-5">
                <div className="bg-gray-50 p-3 rounded-xl border border-gray-100 text-center">
                  <p className="text-xs text-gray-500 mb-1">Eligibility</p>
                  <p className="text-sm font-semibold text-gray-800">{nursingCourses[1].eligibility}</p>
                </div>
                <div className="bg-gray-50 p-3 rounded-xl border border-gray-100 text-center">
                  <p className="text-xs text-gray-500 mb-1">Duration</p>
                  <p className="text-sm font-semibold text-gray-800">{nursingCourses[1].duration}</p>
                </div>
                <div className="bg-gray-50 p-3 rounded-xl border border-gray-100 text-center">
                  <p className="text-xs text-gray-500 mb-1">Fees / Year</p>
                  <p className="text-sm font-semibold text-gray-800">{nursingCourses[1].fees}</p>
                </div>
              </div>
              
              <div className="mb-5">
                <p className="text-sm font-semibold text-gray-700 mb-3 flex items-center gap-2">
                  <span className="w-1 h-4 bg-green-600 rounded-full"></span>
                  Program Highlights
                </p>
                <div className="grid grid-cols-2 gap-2">
                  {nursingCourses[1].features.map((feature, idx) => (
                    <div key={idx} className="flex items-center gap-2 text-gray-700 bg-gray-50 p-2 rounded-lg">
                      <FaCheckCircle className="text-green-600 text-sm flex-shrink-0" />
                      <span className="text-sm">{feature}</span>
                    </div>
                  ))}
                </div>
              </div>
              <div className="mb-5 flex flex-wrap gap-2">
                {nursingCourses[1].highlights.map((item, idx) => (
                  <div key={idx} className="flex items-center gap-1 text-xs text-gray-600 bg-gray-100 px-2 py-1 rounded-full">
                    <BiCertification className="text-green-600" />
                    {item}
                  </div>
                ))}
              </div>

              {/* Admission Details for GNM */}
              <div className="mb-5 bg-gray-50 p-3 rounded-xl border border-gray-200">
                <p className="text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
                  <MdEventNote className="text-green-600" />
                  Admission Details
                </p>
                <div className="grid grid-cols-3 gap-2 text-center text-xs">
                  <div className="bg-white p-2 rounded-lg shadow-sm">
                    <p className="text-gray-500">Start Date</p>
                    <p className="font-bold text-gray-800">1 April 2026</p>
                  </div>
                  <div className="bg-white p-2 rounded-lg shadow-sm">
                    <p className="text-gray-500">Total Seats</p>
                    <p className="font-bold text-gray-800">{nursingCourses[1].seats}</p>
                  </div>
                  <div className="bg-white p-2 rounded-lg shadow-sm">
                    <p className="text-gray-500">Mode</p>
                    <p className="font-bold text-gray-800">Merit Based</p>
                  </div>
                </div>
              </div>

              <div className="flex gap-3">
                <button className="flex-1 py-3 px-4 bg-gradient-to-r from-green-600 to-green-700 text-white text-sm font-semibold rounded-xl hover:from-green-700 hover:to-green-800 transition-all duration-300 transform group-hover:scale-[1.02] flex items-center justify-center gap-2 shadow-lg shadow-green-200">
                  Apply Now <FaArrowRight className="group-hover:translate-x-1 transition-transform" />
                </button>
                <button className="px-4 py-3 border-2 border-green-600 text-green-600 text-sm font-semibold rounded-xl hover:bg-green-50 transition-all duration-300">
                  Download Brochure
                </button>
              </div>
            </div>
          </div>
        </div>
        
        {/* Important Information Section */}
        <div className="bg-white rounded-2xl shadow-xl p-6 border-l-4 border-blue-600 relative overflow-hidden">
          <div className="absolute top-0 right-0 w-48 h-48 bg-blue-100 rounded-full -mr-24 -mt-24 opacity-50"></div>
          
          <div className="relative">
            <h4 className="text-xl font-bold text-gray-800 mb-4 flex items-center gap-2">
              <MdMedicalServices className="text-blue-600 text-2xl" />
              Important Information
            </h4>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="space-y-3">
                <div className="flex items-start gap-3">
                  <div className="w-5 h-5 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <span className="text-blue-600 text-xs font-bold">1</span>
                  </div>
                  <p className="text-gray-700 text-sm">
                    <span className="font-semibold">B.Sc. Nursing:</span> A comprehensive 4-year program approved by the Indian Nursing Council. 
                    Eligibility: 10+2 with PCB (50%). Includes advanced clinical training and nursing research.
                  </p>
                </div>
                
                <div className="flex items-start gap-3">
                  <div className="w-5 h-5 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <span className="text-green-600 text-xs font-bold">2</span>
                  </div>
                  <p className="text-gray-700 text-sm">
                    <span className="font-semibold">GNM Course:</span> A 3-year diploma program open for all with 10+2 any stream. 
                    Includes comprehensive training in nursing care, midwifery, and obstetric care with integrated pharmacy career training.
                  </p>
                </div>
              </div>
              
              <div className="space-y-3">
                <div className="flex items-start gap-3">
                  <div className="w-5 h-5 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <span className="text-blue-600 text-xs font-bold">3</span>
                  </div>
                  <p className="text-gray-700 text-sm">
                    <span className="font-semibold">Clinical Training:</span> Hands-on experience in affiliated hospitals 
                    and pharmaceutical companies from first year.
                  </p>
                </div>
                
                <div className="flex items-start gap-3">
                  <div className="w-5 h-5 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <span className="text-green-600 text-xs font-bold">4</span>
                  </div>
                  <p className="text-gray-700 text-sm">
                    <span className="font-semibold">Admissions Open:</span> Apply before June 30th, 2025 for early bird scholarship benefits.
                  </p>
                </div>
              </div>
            </div>
            <div className="mt-6 bg-gradient-to-r from-blue-600 to-green-600 rounded-xl p-4 text-white flex flex-wrap items-center justify-between gap-4">
              <div className="flex items-center gap-3">
                <FaGraduationCap className="text-3xl" />
                <div>
                  <p className="font-bold text-lg">Limited Seats Available</p>
                  <p className="text-sm opacity-90">Apply now for the 2025-26 academic session</p>
                </div>
              </div>
              <button className="bg-white text-blue-700 px-6 py-2 rounded-lg font-semibold text-sm hover:bg-blue-50 transition-colors shadow-lg">
                Download Brochure →
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NursingCoursesSection;